import Vue from 'vue';

import components from '@/components';
import config from '@/config';
import store from '@/store';

import { mapMutations, mapState } from 'vuex';

config.init();

const app = new Vue({ //eslint-disable-line
    el: '#app',
    components,
    store,
    computed: {
        ...mapState({
            modal: state => state.modal.modal,
            orderType: state => state.cart.orderType,
        }),
    },
    methods: {
        ...mapMutations({
            setModal: 'modal/setModal',
        }),
    },
});
